module.exports = __webpack_public_path__ + "img/general-group-seating-map-3.913018c1.jpg";